/**
 * @file: useUserPermissions.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { UserPermissions } from '@euler/model';

export const useUserPermissions = (): UserPermissions | undefined => {
  return useUserProfileInfo()?.user.permissions;
};
